import { Action } from '@ngrx/store';

export enum LogsActionTypes {
  ExportLogs = '[Logs] Export logs',
  ExportLogsSuccess = '[Logs] Export logs success',
  ExportLogsFail = '[Logs] Export logs fail'
}

export class ExportLogs implements Action {
  readonly type = LogsActionTypes.ExportLogs;
  constructor(public data1: any, public data2: any) {}
}

export class ExportLogsSuccess implements Action {
  readonly type = LogsActionTypes.ExportLogsSuccess;
  constructor() {}
}

export class ExportLogsFail implements Action {
  readonly type = LogsActionTypes.ExportLogsFail;
  constructor() {}
}

export type RuleActionsUnion = ExportLogs | ExportLogsSuccess | ExportLogsFail;
